import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactElement } from 'react';
import { ReactComponent as Icon } from '../../assets/icons/icon-pdf.svg';

export default function Pdf(props: SvgIconProps): ReactElement {
  return <SvgIcon component={Icon} {...props} viewBox="0 0 384 512" />;
}
